export const INIT_USER_FALLBACK = 'INIT_USER_FALLBACK'
export const FETCH_USER_FALLBACK_SUCCESS = 'FETCH_USER_FALLBACK_SUCCESS'
export const FETCH_USER_FALLBACK_FAIL = 'FETCH_USER_FALLBACK_FAIL'
export const INIT_UPDATE_USER_FALLBACK_DATA = 'INIT_UPDATE_USER_FALLBACK_DATA'
export const UPDATE_USER_FALLBACK_DATA_SUCCESS =
  'UPDATE_USER_FALLBACK_DATA_SUCCESS'
export const UPDATE_USER_FALLBACK_DATA_FAIL = 'UPDATE_USER_FALLBACK_DATA_FAIL'
export const LOCAL_FALLBACK_BUTTONS_UPDATE = 'LOCAL_FALLBACK_BUTTONS_UPDATE'
